export const updateUrl = function({ inputUrl , productHandle , variantId  }) {
    const url = new URL(inputUrl);
    const pathSegments = url.pathname.split('/');
    const actualHandle = pathSegments[pathSegments.length - 1];
    const pageType = pathSegments[pathSegments.length - 2];
    if (pageType !== 'products') {
        return inputUrl;
    }
    if (actualHandle !== productHandle) {
        return inputUrl;
    }
    url.searchParams.set('variant', variantId.toString());
    return url.toString();
};
export const updateAddressBar = function({ productHandle , variantId  }) {
    try {
        const inputUrl = window.location.href;
        const nextUrl = updateUrl({
            inputUrl,
            productHandle,
            variantId
        });
        if (nextUrl === inputUrl) {
            return;
        }
        window.history.replaceState(null, document.title, nextUrl);
    } catch (err) {
        console.error(err);
    }
};
